//SetupSlide.js
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite/no-important";
import Button from "@material-ui/core/Button";
import Snackbar from "components/Snackbar";
import FullPageLoader from "components/FullPageLoader";
import Server from "components/Server";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Visibility from "@material-ui/icons/Visibility";
import Assignment from "@material-ui/icons/Assignment";
import TextField from "@material-ui/core/TextField";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Common from "./Common";
import Cache from "Cache";
import img_m1 from "imgs/m1.PNG";
import img_m2 from "imgs/m2.PNG";
import img_mcm1 from "imgs/mcm1.PNG";
import img_mcm2 from "imgs/mcm2.PNG";
import img_mcm3 from "imgs/mcm3.PNG";
import img_mcm4 from "imgs/mcm4.PNG";
import img_mcm5 from "imgs/mcm5.PNG";
import img_m1_tokens from "imgs/editea_plugin_tokens.png";
import img_m1_host from "imgs/editea_plugin_host_url.png";
import img_m2_tokens from "imgs/editea_plugin_tokens_magento2.png";
import img_m2_host from "imgs/editea_plugin_host_url_magento2.png";
import magento2_composer from "imgs/magento2_composer.png";
import shopify_logo from "imgs/Shopify_logo_2018.svg";
import editea_plugin_magento1 from "assets/Editea_Sorter-1.0.0-magento1.zip"
import editea_plugin_magento2 from "assets/Editea_Sorter-magento2.tar.gz"

const styles = {
	root: {
		width: "100%",
		height: "100%",
		maxWidth: "100%",
		display: "flex",
		flexDirection: "column",
		flexWrap: "nowrap",
		position: "relative",
		justifyContent: "space-between",
		alignItems: "center"
	},
	slider: {
		width: "100%",
		flex: "1",
		display: "flex",
		justifyContent: "center",
		alignItems: "flex-start",
		flexWrap: "nowrap",
		overflowY: "auto",
		overflowX: "hidden"
	},
	buttomBar: {
		height: "50px",
		minHeight: "50px",
		width: "100%",
		maxWidth: "100%",
		backgroundColor: "white",
		boxShadow: "0px 0px 15px rgba(0,0,0,0.2)",
		position: "relative",
		zIndex: 2,
		overflow: "hidden",
		boxSizing: "border-box",
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		flexWrap: "nowrap",
		padding: "0px 15px"
	},
	buttomBarButtons: {
		width: "176px",
		boxSizing: "border-box",
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between"
	},
	page1: {
		width: "100%",
		padding: "5vw 2vw",
		textAlign: "center"
	},
	page2: {
		width: "100%",
		padding: "5vw 2vw",
		textAlign: "center"
	},
	page3: {
		width: "100%",
		padding: "5vw 2vw",
		textAlign: "center"
	},
	pageWidth: {
		width: "100%",
		maxWidth: "1250px"
	},
	tokenGridContainer: {
		position: "relative"
	},
	visibilityIcon: {
		position: "absolute",
		top: "calc(50% - 40px)",
		right: "5px"
	},
	copyToClipboartdIcon: {
		position: "absolute",
		top: "calc(50% - 40px)",
		right: "45px"
	},
	expansionPanelBox: {
		width: "100%",
		display: "flex",
		justifyContent: "center"
	},
	expansionPanel: {
		width: "90%",
		maxWidth: "900px"
	},
	expansionPanelDetails: {
		textAlign: "left"
	},
	numbering: {
		color: "#f50057",
		fontWeight: "700",
		fontSize: "20px"
	},
	image: {
		width: "100%",
		height: "auto",
		maxWidth: "100%"
	},
	setupProgress: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		width: "100%",
		boxSizing: "border-box"
	},
	setupProgressNumber: {
		height: "35px",
		width: "35px",
		border: "2px solid",
		borderRadius: "50%",
		textAlign: "center",
		lineHeight: "32px",
		fontSize: "1rem",
		fontWeight: "300",
		color: "#333",
		margin: "0px 7px"
	}
};
const className = StyleSheet.create({
	card: { width: "90%", maxWidth: "900px" },
	center: { display: "flex", justifyContent: "center" },
	heading: {
		fontSize: "1.3rem",
		fontWeight: "300"
	},
	margin: {
		margin: "5px"
	}
});

class SetupSlide extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			setupProgress: 1,
			tokenApiInput: "0123456789",
			userApiInput: "0123456789",
            hostApiInput: "",
            shopifyShopInput: "",
            hostApiInputError: false,
            shopifyShopInputError: false,
			showUserApi: false,
			showTokenApi: false
		};
		this.tokenApiRef = React.createRef();
		this.userApiRef = React.createRef();
		this.toggleVisibility = this.toggleVisibility.bind(this);
		this.getTokenDone = this.getTokenDone.bind(this);
		this.doToggleVisibility = this.doToggleVisibility.bind(this);
		this.downloadDirectFromEditea = this.downloadDirectFromEditea.bind(
			this
		);
	}

	backOnClick = () => {
		this.setState({ setupProgress: this.state.setupProgress - 1 });
	};
	nextOnClick = () => {
		this.setState({ setupProgress: this.state.setupProgress + 1 });
	};
	doneOnClick = () => {
        const shopify = this.props.platform == "shopify";
		if (this.state.hostApiInput.length == 0) {
			this.setState({ hostApiInputError: true });
			return;
        }
        if (shopify && this.state.shopifyShopInput.length == 0) {
			this.setState({ shopifyShopInputError: true });
			return;
		}
        FullPageLoader.open("Connecting your system");
        let data = { host_api: this.state.hostApiInput }
        if (shopify) {
            data.shopify_shop = this.state.shopifyShopInput;
        }
		Server.post(
			"/settings/checkauth",
			data,
			this.checkAuthDone.bind(this)
		);
	};

	checkAuthDone(res) {
		FullPageLoader.close();
		if (res.data.checkAuth == true) {
			Snackbar.info("Welcome to editea");
			this.props.closeSetupSlide();
		} else Snackbar.error("Connection to your system was failed");
	}

	openUrl = url => {
		var win = window.open(url, "_blank");
		win.focus();
	};

	inputOnChange = name => event => {
		let value = event.target.value;
		this.setState({ [name]: value });
		if (
			name === "hostApiInput" &&
			value.length > 0 &&
			this.state.hostApiInputError
		)
			this.setState({ hostApiInputError: false });
	};

	toggleVisibility(toggleName) {
		if (Cache.settings && Cache.settings.user_api)
			this.doToggleVisibility(toggleName);
		else
			Server.post("/settings/get_token", {}, res =>
				this.getTokenDone(res, toggleName)
			);
	}

	getTokenDone(res, toggleName) {
		let settings = res.data.settings;
		if (Cache.settings == null) Cache.settings = {};
		Cache.settings.user_api = settings.user_api;
		Cache.settings.token_api = settings.token_api;
		this.doToggleVisibility(toggleName);
	}

	doToggleVisibility(toggleName) {
		if (toggleName == "userApi") {
			this.setState({
				showUserApi: !this.state.showUserApi,
				userApiInput: !this.state.showUserApi
					? Cache.settings && Cache.settings.user_api
					: "0123456789"
			});
		} else if (toggleName == "tokenApi") {
			this.setState({
				showTokenApi: !this.state.showTokenApi,
				tokenApiInput: !this.state.showTokenApi
					? Cache.settings && Cache.settings.token_api
					: "0123456789"
			});
		}
	}

	renderPage1() {
		if (this.state.setupProgress != 1) return null;
		let isMagento2 = this.props.platform == "magento2";
		return (
			<div style={styles.page1}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Typography variant="h2" color={"primary"} gutterBottom>
							STEP 1 - DOWNLOAD EDITEA PLUGIN
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Card>
							<CardContent>
								<Typography
									variant="h4"
									color={"secondary"}
									gutterBottom
								>
									Option 1
								</Typography>
								<Typography variant="h5" gutterBottom>
									Download from Magento Marketplace
								</Typography>
								<Button
									classes={{ root: css(className.margin) }}
									variant="extendedFab"
									color="primary"
									onClick={() =>
										this.openUrl(
											"https://marketplace.magento.com/editea-editea-sorter.html"
										)
									}
								>
									Magento marketplace
								</Button>
							</CardContent>
						</Card>
					</Grid>
					<Grid item xs={6}>
						<Card>
							<CardContent>
								<Typography
									variant="h4"
									color={"secondary"}
									gutterBottom
								>
									Option 2
								</Typography>
								<Typography variant="h5" gutterBottom>
									Download from Github / Direct from editea
								</Typography>
								<Button
									classes={{ root: css(className.margin) }}
									variant="extendedFab"
									color="primary"
									onClick={() =>
										this.openUrl(
											"https://github.com/Editea/Sorter"
										)
									}
								>
									Download From Github
								</Button>
								<Button
									classes={{ root: css(className.margin) }}
									variant="extendedFab"
									color="primary"
								>
									{!isMagento2 && (
										<a
											style={{
												color: "white",
												textDecoration: "none"
											}}
											href={editea_plugin_magento1}
											download="Editea_Sorter-1.0.0-magento1.zip"
										>
											Download Direct From Editea
										</a>
									)}
									{isMagento2 && (
										<a
											style={{
												color: "white",
												textDecoration: "none"
											}}
											href={editea_plugin_magento2}
											download="Editea_Sorter-magento2.tar.gz"
										>
											Download Direct From Editea
										</a>
									)}
								</Button>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</div>
		);
	}

	downloadDirectFromEditea = e => {
		let url =
			this.props.platform != "magento2"
				? "/Editea_Sorter-1.0.0-magento1.zip"
				: "/Editea_Sorter-magento2.tar.gz";
		this.openUrl(url);
	};

	renderPage2() {
		if (this.state.setupProgress != 2) return null;
		let isMagento2 = this.props.platform == "magento2";
		return (
			<div style={styles.page2}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Typography variant="h2" color={"primary"} gutterBottom>
							STEP 2 - INSTALL EDITEA PLUGIN
						</Typography>
					</Grid>
					<Grid
						item
						xs={12}
						classes={{ item: css(className.center) }}
					>
						<div style={styles.expansionPanelBox}>
							<div style={styles.expansionPanel}>
								<ExpansionPanel>
									<ExpansionPanelSummary
										expandIcon={<ExpandMoreIcon />}
									>
										<Typography
											className={css(className.heading)}
										>
											{isMagento2 == false
												? "Manual Installation"
												: "Install via Composer"}
										</Typography>
									</ExpansionPanelSummary>
									<ExpansionPanelDetails>
										{isMagento2 == false
											? this.renderMenualInstallationMagento1()
											: this.renderMenualInstallationMagento2()}
									</ExpansionPanelDetails>
								</ExpansionPanel>
								{isMagento2 == false && (
									<ExpansionPanel>
										<ExpansionPanelSummary
											expandIcon={<ExpandMoreIcon />}
										>
											<Typography
												className={css(
													className.heading
												)}
											>
												Magento Connect Marketplace
											</Typography>
										</ExpansionPanelSummary>
										<ExpansionPanelDetails>
											{isMagento2 == false
												? this.renderMagentoConnectMarketplaceMagento1()
												: this.renderMagentoConnectMarketplaceMagento2()}
										</ExpansionPanelDetails>
									</ExpansionPanel>
								)}
							</div>
						</div>
					</Grid>
				</Grid>
			</div>
		);
	}

	renderMenualInstallationMagento1() {
		return (
			<div style={styles.expansionPanelDetails}>
				<p>
					<span style={styles.numbering}>1.</span> Login into the
					backend and go to System --> Cache Management --> Enable All
					Cache Types
				</p>
				<p>
					<span style={styles.numbering}>2.</span> Go to System -->
					Tools --> Compilation and make sure it “Compiler Status:
					Disabled”. Otherwise, please disable the compilation:
				</p>
				<img
					src={img_m1}
					style={{
						...styles.image,
						...{ width: "433px" }
					}}
				/>
				<p>
					<span style={styles.numbering}>3.</span> Upload all the
					extension files from “Editea_Sorter” folder to the root
					folder of your Magento installation:
				</p>
				<img
					src={img_m2}
					style={{
						...styles.image,
						...{ width: "637px" }
					}}
				/>
				<p>
					<span style={styles.numbering}>4.</span> Go to System -->
					Cache Management page at your Magento backend, and click the
					“Flush Cache Storage” button. After this action, the
					extension is installed.
				</p>
				<span style={styles.numbering}>5.</span> If you need to enable
				Compilation, please go to System --> Tools --> Compilation and
				click “Run Compilation Process” button.
				<p>
					<span style={styles.numbering}>6.</span> Please log out from
					the backend and log in again for Magento to refresh
					permissions.
				</p>
			</div>
		);
	}

	renderMenualInstallationMagento2() {
		return (
			<div
				style={{
					...styles.expansionPanelDetails,
					...{ maxWidth: "620px" }
				}}
			>
				<p>
					To install Editea Sorter via composer , execute the
					following command in Magento’s root directory:
				</p>
				<p
					style={{
						backgroundColor: "#f1f1f1",
						borderRadius: "3px",
						padding: "10px 15px"
					}}
				>
					composer require editea/magento-2-sorter && / <br />
					php bin/magento setup:upgrade && / <br />
					php bin/magento setup:static-content:deploy
				</p>
				<p>
					If you encounter an “Authencaon Required” message, visit
					Magento’s
					<span
						onClick={() => {
							this.openUrl(
								"https://account.magento.com/applications/customer/login/"
							);
						}}
						style={{ color: "#3498db", cursor: "pointer" }}
					>
						{" "}
						Access Keys{" "}
					</span>
					page and{" "}
					<span
						style={{
							backgroundColor: "#f5f5f5",
							borderRadius: "3px",
							padding: "1px",
							fontWeight: "500"
						}}
					>
						Create A New Access Key{" "}
					</span>
					.
				</p>
				<img
					src={magento2_composer}
					style={{
						...styles.image,
						...{ width: "100%", maxWidth: "602px" }
					}}
				/>
				<p>Alternavely, use these keys:</p>
				<p
					style={{
						backgroundColor: "#f1f1f1",
						borderRadius: "3px",
						padding: "10px 15px"
					}}
				>
					Public Key: c7af1bfc9352e9c986637eec85ed53af <br />
					Private Key: 17e1b72ea5f0b23e9dbfb1f68dc12b53
				</p>
			</div>
		);
	}

	renderMagentoConnectMarketplaceMagento1() {
		return (
			<div style={styles.expansionPanelDetails}>
				<p>
					<span style={styles.numbering}>1.</span> First you need to
					log into the Magento administrator area, and then go to
					System > Magento Connect > Magento Connect Manager. This
					screen will appear:
				</p>
				<img
					src={img_mcm1}
					style={{
						...styles.image,
						...{ width: "702px" }
					}}
				/>
				<p>
					<span style={styles.numbering}>2.</span> Try to login with
					admin account and you can see:
				</p>
				<img
					src={img_mcm2}
					style={{
						...styles.image,
						...{ width: "618px" }
					}}
				/>
				<p>
					<span style={styles.numbering}>3.</span> Now to go Magento
					Connect to get an extension key
				</p>
				<img
					src={img_mcm3}
					style={{
						...styles.image,
						...{ width: "381px" }
					}}
				/>
				<img
					src={img_mcm4}
					style={{
						...styles.image,
						...{ width: "436px" }
					}}
				/>
				<p>
					<span style={styles.numbering}>4.</span> Then paste the key
					to install and click the Install button, then click Process
					to download and install the Better Blog extension on your
					Magento store.
				</p>
				<img
					src={img_mcm5}
					style={{
						...styles.image,
						...{ width: "606px" }
					}}
				/>
			</div>
		);
	}

	renderPage3() {
		if (this.state.setupProgress != 3) return null;
		let isMagento2 = this.props.platform == "magento2";
		return (
			<div style={styles.page3}>
				<Grid
					container
					spacing={24}
					classes={{ container: css(className.center) }}
				>
					<Grid item xs={12}>
						<Typography variant="h2" color={"primary"} gutterBottom>
							STEP 3 - SET USER & TOKEN API
						</Typography>
					</Grid>
					<Grid
						classes={{ item: css(className.center) }}
						item
						xs={12}
					>
						<Card classes={{ root: css(className.card) }}>
							<CardContent>
								<Typography
									variant="h4"
									color={"secondary"}
									gutterBottom
								>
									Make sure no one is behind you!
								</Typography>
								<Typography variant="h5" gutterBottom>
									Copy the tokens inside editea plugin on your
									system
								</Typography>
								<Grid
									container
									spacing={24}
									direction="row"
									justify="center"
									alignItems="center"
								>
									<Grid
										key={"Grid_User_Api"}
										style={styles.tokenGridContainer}
										item
										xs={10}
									>
										<TextField
											inputRef={ref =>
												(this.userApiRef = ref)
											}
											id="user_api"
											type={
												this.state.showUserApi
													? "text"
													: "password"
											}
											label={"User API"}
											value={this.state.userApiInput}
											margin="normal"
											fullWidth
											error={false}
										/>
										<div style={styles.visibilityIcon}>
											<Button
												aria-label="Toggle user api visibility"
												onClick={() =>
													this.toggleVisibility(
														"userApi"
													)
												}
											>
												{this.state.showUserApi ? (
													<VisibilityOff />
												) : (
													<Visibility />
												)}
											</Button>
										</div>
										{this.state.showUserApi && (
											<div
												style={
													styles.copyToClipboartdIcon
												}
											>
												<Button
													aria-label="Copy to clipboard"
													onClick={() =>
														Common.copyToClipboartd(
															this.userApiRef,
															"User API"
														)
													}
												>
													<Assignment />
												</Button>
											</div>
										)}
									</Grid>
									<Grid
										key={"Grid_Token"}
										style={styles.tokenGridContainer}
										item
										xs={10}
									>
										<TextField
											inputRef={ref =>
												(this.tokenApiRef = ref)
											}
											id="token"
											type={
												this.state.showTokenApi
													? "text"
													: "password"
											}
											label={"Token API"}
											value={this.state.tokenApiInput}
											margin="normal"
											fullWidth
											error={false}
										/>
										<div style={styles.visibilityIcon}>
											<Button
												aria-label="Toggle token visibility"
												onClick={() =>
													this.toggleVisibility(
														"tokenApi"
													)
												}
											>
												{this.state.showTokenApi ? (
													<VisibilityOff />
												) : (
													<Visibility />
												)}
											</Button>
										</div>
										{this.state.showTokenApi && (
											<div
												style={
													styles.copyToClipboartdIcon
												}
											>
												<Button
													aria-label="Copy to clipboard"
													onClick={() =>
														Common.copyToClipboartd(
															this.tokenApiRef,
															"Token API"
														)
													}
												>
													<Assignment />
												</Button>
											</div>
										)}
									</Grid>
								</Grid>
								<div
									style={{
										width: "100%",
										marginTop: "30px",
										marginBottom: "20px"
									}}
								>
									<Typography variant="h5" gutterBottom>
										This is how it should look like...
									</Typography>
								</div>
								{!isMagento2 && (
									<img
										src={img_m1_tokens}
										style={styles.image}
									/>
								)}
								{isMagento2 && (
									<img
										src={img_m2_tokens}
										style={styles.image}
									/>
								)}
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</div>
		);
	}

	renderPage4() {
        if (this.state.setupProgress != 4) return null;
        let isMagento2 = this.props.platform == "magento2";
        let shopify = this.props.platform == "shopify";
		return (
			<div style={styles.page2}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Typography variant="h2" color={"primary"} gutterBottom>
							STEP 4 - COPY HOST API URL
						</Typography>
					</Grid>
					<Grid
						item
						xs={12}
						classes={{ item: css(className.center) }}
					>
						<Card classes={{ root: css(className.card) }}>
							<CardContent>
								<Typography
									variant="h4"
									color={"secondary"}
									gutterBottom
								>
									Copy your system host api here
								</Typography>
								<Grid container spacing={2} justify={"center"}>
                                <Grid key={"Grid_User_Api"} item xs={10}>
										<TextField
											required
											id="host_api"
											type="text"
											label={"Host Api"}
											value={this.state.hostApiInput}
											margin="normal"
											fullWidth
											onChange={this.inputOnChange(
												"hostApiInput"
											)}
											error={this.state.hostApiInputError}
											helperText={
												this.state.hostApiInputError
													? "Required field can't be empty!"
													: null
											}
										/>
									</Grid>
                                    <Grid key={"Grid_Shopify_Shop"} item xs={10}>
										<TextField
											required
											id="shopify_shop"
											type="text"
											label={"Shopify Shop"}
											value={this.state.shopifyShopInput}
											margin="normal"
											fullWidth
											onChange={this.inputOnChange(
												"shopifyShopInput"
											)}
											error={this.state.shopifyShopInputError}
											helperText={
												this.state.shopifyShopInputError
													? "Required field can't be empty!"
													: null
											}
										/>
									</Grid>
								</Grid>
								<div
									style={{
										width: "100%",
										marginTop: "30px",
										marginBottom: "20px"
									}}
								>
									<Typography variant="h5" gutterBottom>
										You can copy it from editea plugin. just
										hit the "Copy to clipboard" button and
										paste it here on "Host Api" field.
									</Typography>
								</div>
                                {!isMagento2 && !shopify &&
								<img
									src={img_m1_host}
									style={styles.image}
								/>
                                }
                                {isMagento2 && 
								<img
									src={img_m2_host}
									style={styles.image}
								/>
                                }
                                {shopify && 
                                <img
									src={shopify_logo}
									style={{...styles.image, maxWidth: "60%"}}
								/>
                                }
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</div>
		);
	}

	renderSlider() {
		return (
			<div style={styles.slider}>
				<div style={styles.pageWidth}>
					{this.renderPage1()}
					{this.renderPage2()}
					{this.renderPage3()}
					{this.renderPage4()}
				</div>
			</div>
		);
	}

	renderSetupProgress() {
		return (
			<div style={styles.setupProgress}>
				<div
					style={{
						...styles.setupProgressNumber,
						...(this.state.setupProgress === 1
							? { borderColor: "#f50057" }
							: { borderColor: "#3f51b5" })
					}}
				>
					1
				</div>
				<div
					style={{
						...styles.setupProgressNumber,
						...(this.state.setupProgress === 2
							? { borderColor: "#f50057" }
							: { borderColor: "#3f51b5" })
					}}
				>
					2
				</div>
				<div
					style={{
						...styles.setupProgressNumber,
						...(this.state.setupProgress === 3
							? { borderColor: "#f50057" }
							: { borderColor: "#3f51b5" })
					}}
				>
					3
				</div>
				<div
					style={{
						...styles.setupProgressNumber,
						...(this.state.setupProgress === 4
							? { borderColor: "#f50057" }
							: { borderColor: "#3f51b5" })
					}}
				>
					4
				</div>
			</div>
		);
	}

	renderBottomBar() {
		return (
			<div style={styles.buttomBar}>
				<div style={{ width: "176px" }} />
				<div>{this.renderSetupProgress()}</div>
				<div style={styles.buttomBarButtons}>
					{this.state.setupProgress > 1 && (
						<Button color="primary" onClick={this.backOnClick}>
							Previous
						</Button>
					)}
					<div style={{ width: "10px" }} />
					{this.state.setupProgress < 4 && (
						<Button
							variant="contained"
							color="primary"
							onClick={this.nextOnClick}
						>
							Next
						</Button>
					)}
					{this.state.setupProgress === 4 && (
						<Button
							variant="contained"
							color="primary"
							onClick={this.doneOnClick}
						>
							Done
						</Button>
					)}
				</div>
			</div>
		);
	}

	render() {
		return (
			<div style={styles.root}>
				{this.renderSlider()}
				{this.renderBottomBar()}
			</div>
		);
	}
}

export default SetupSlide;
